<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
    <Loading v-if="loading"/>
    <div v-else class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
         id="kt_content">
      <!-- begin:: Content -->
      <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <!--begin::Portlet-->

        <div v-if="criticalErrorsList && criticalErrorsList.length > 0"
             class="kt-portlet__body app_service__form-body">
          <div v-for="error in criticalErrorsList"
               class="alert alert-warning fade show"
               role="alert">
            <div class="alert-icon"><i class="flaticon-warning"></i></div>
            <div class="alert-text">{{ error }}</div>
          </div>
        </div>

        <div v-else class="kt-portlet">
          <div class="kt-portlet__body">

            <!--begin::Section-->
            <div class="kt-section__content">
              <h2>{{card.theme}}</h2>
              Заявка {{card.number}}
            </div>
            <!--end::Section-->
          </div>

          <!--end::Form-->
        </div>

        <div class="row" v-if="!criticalErrorsList || criticalErrorsList.length === 0">
          <div class="col-xl-8">

            <!--begin:: Widgets/Order Statistics-->
            <div class="kt-portlet kt-portlet--height-fluid">
              <div class="kt-portlet__body kt-portlet__body--fluid">
                <div class="kt-widget12">
                  <div>Тип заявки: {{card.type}}</div>
                  <h5>Описание:</h5>
                  <div>
                    <div v-html="card.description"></div>
                  </div>

                  <div class="app_comments">
                    <h6 class="app_comments__title">Комментарии:</h6>
                    <div class="app_comments__comment" v-for="comment in card.comments">
                      <div class="app_comments__comment-title">
                        <template v-if="comment.author">
                          {{comment.author}},
                        </template>
                        <template v-else>
                          Суперпользователь,
                        </template>
                        {{comment.created_at | formatDateTime}}
                      </div>
                      <div class="app_comments__comment-text">
                        <div v-html="comment.text"></div>
                      </div>
                    </div>
                  </div>

                  <Loading v-show="commentLoading"/>
                  <form v-show="!commentLoading" action="" v-on:submit.prevent="saveComment" class="app__new-comment">
                    <div class="form-group">
                      <label for="new-comment">Добавить комментарий</label>
                      <textarea class="form-control" id="new-comment" v-model="commentText"
                                rows="3"></textarea>
                    </div>

                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group" v-for="fileInput in fileInputsList">
                          <label>Файлы</label>
                          <input type="file" class="form-control-file" :name="fileInput">
                        </div>
                        <div class="form-group form-group-last app_service__form--add-file-input">
                          <a href="javascript:void(0)" title="добавить еще один файл"
                             v-on:click="addFileInput">+ еще один файл</a>
                        </div>
                      </div>
                      <div class="col-xl-6 text-right">
                        <button type="submit" class="btn btn-primary">Отправить</button>
                      </div>
                    </div>
                  </form>

                </div>
              </div>
            </div>

            <!--end:: Widgets/Order Statistics-->
          </div>
          <div class="col-xl-4">
            <!--begin:: Widgets/Tasks -->
            <div class="kt-portlet kt-portlet--tabs kt-portlet--height-fluid">
              <div class="kt-portlet__head">
                <div class="kt-portlet__head-label">
                  <h3 class="kt-portlet__head-title">
                    Контрагент
                  </h3>
                </div>
              </div>

              <div class="kt-portlet__body">

                <div v-for="title in card.clientName">
                  {{title}}
                </div>
                <div>{{card.clientEmail}}</div>
                <div v-for="phone in card.clientPhone">
                  {{phone}}
                </div>
                <br>

                <div>Статус: {{card.state}}</div>
                <div>Дата регистрации: {{card.created_at | formatDateTime}}</div>
                <div>Регламентное время решения: {{card.deadline.deadLineTime | formatDateTime}}</div>
              </div>
            </div>

            <!--end:: Widgets/Tasks -->
          </div>
        </div>
        <!--end::Portlet-->
      </div>


      <!-- end:: Content -->
    </div>
  </div>
</template>

<script>
import Api from '../Api';
import Loading from '../components/Loading';
import i18n from '../i18n';
import router from '../router';
import FileUploader from '../modules/FileUploader';

export default {
  name: 'ServiceCallView',
  data() {
    return {
      criticalErrorsList: [],
      loading: true,
      commentLoading: false,
      fileInputsList: [
        'files[]',
      ],
      card: {},
      user: {
        id: 0,
        email: 0,
      },
      commentText: '',
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    addFileInput() {
      this.fileInputsList.push('files[]');
    },
    uploadFiles(listElementId) {
      return new Promise((resolve, reject) => {
        const diskPath = `/service_call_comment_files/${listElementId}`;
        const fileInputs = document.querySelectorAll('.app__new-comment input[type=file]');

        const filesUploaded = FileUploader.uploadToDisk(diskPath, fileInputs);

        filesUploaded.then((uploadedFileIDs) => {
          resolve(uploadedFileIDs);
        });

        filesUploaded.catch((reason) => {
          reject(reason);
        });
      });
    },
    attachFilesToComment(params, uploadedFileIds) {
      return new Promise((resolve, reject) => {
        const diskFieldId = this.$root.app_data.comment.fields.DISK.field_id;

        params.FIELDS[diskFieldId] = uploadedFileIds;

        window.BX24.callMethod(
          'lists.element.update',
          params,
          (result) => {
            if (result.error()) {
              reject(result.error());
            } else {
              resolve();
            }
          },
        );
      });
    },
    saveComment() {
      this.commentLoading = true;
      this.errorsList = [];
      const timestamp = new Date().getTime();

      const descriptionFieldId = this.$root.app_data.comment.fields.DESCRIPTION.field_id;
      const serviceCallFieldId = this.$root.app_data.comment.fields.SERVICE_CALL.field_id;

      const params = {
        IBLOCK_TYPE_ID: 'lists',
        IBLOCK_CODE: 'sd_service_call_comment',
        ELEMENT_CODE: `request_${this.user.id}${timestamp}`,
        FIELDS: {
          NAME: `Comment for ${this.card.UUID}`,
        },
      };

      params.FIELDS[descriptionFieldId] = this.commentText;
      params.FIELDS[serviceCallFieldId] = this.card.UUID;

      window.BX24.callMethod(
        'lists.element.add',
        params,
        (result) => {
          if (result.error()) {
            this.errorsList.push(result.error());
            this.commentLoading = false;
          } else {
            delete params.ELEMENT_CODE;
            params.ELEMENT_ID = result.data();
            const filesUploaded = this.uploadFiles(params.ELEMENT_ID);
            filesUploaded.then((uploadedFileIds) => {
              if (uploadedFileIds.length > 0) {
                const filesAttached = this.attachFilesToComment(params, uploadedFileIds);
                filesAttached.then(() => {
                  this.sendToQueue(params.ELEMENT_ID);
                });

                filesAttached.catch((error) => {
                  this.errorsList.push(error);
                  this.commentLoading = false;
                });
              } else {
                this.sendToQueue(params.ELEMENT_ID);
              }
            });

            filesUploaded.catch((error) => {
              this.errorsList.push(error);
              this.commentLoading = false;
            });
          }
        },
      );
    },
    sendToQueue(elementId) {
      if (this.errorsList.length > 0) {
        this.commentLoading = false;
      } else {
        const request = Api.startCommentProcessing(elementId);
        request.finally(() => {
          this.fileInputsList = [];
          this.fileInputsList.push('files[]');

          const timestamp = new Date();
          this.card.comments.unshift({
            author: this.user.email,
            text: this.commentText,
            created_at: timestamp,
          });
          this.commentText = '';
          this.commentLoading = false;
        });
      }
    },
    saveComment111() {
      this.commentLoading = true;
      const request = Api.saveComment(this.user.email, this.card.id, this.commentText);
      request.then((response) => {
        const timestamp = new Date();
        this.card.comments.unshift({
          author: this.user.email,
          text: this.commentText,
          created_at: timestamp,
        });
        this.commentText = '';
        console.log(this.card);
      });
      request.catch((error) => {
        if (error.response.data) {
          this.error = error.response.data.error;
        } else {
          this.error = i18n.t('Ошибка отображения');
        }
      });
      request.finally(() => {
        this.commentLoading = false;
      });
    },
    fetchData() {
      this.loading = true;
      const request = Api.getServiceCall(this.$route.params.id);
      request.then((response) => {
        if (response.data.errors && response.data.errors.length > 0) {
          response.data.errors.forEach((el) => {
            this.criticalErrorsList.push(el);
          });
        } else {
          this.card = response.data.card;
        }
      });
      request.catch((error) => {
        if (error.response.data) {
          this.error = error.response.data.error;
        } else {
          this.error = i18n.t('Ошибка отображения');
        }
      });
      request.finally(() => {
        this.loading = false;
      });
    },
  },
  components: {
    Loading,
  },
};
</script>

<style lang="scss">
  #kt_content {
    color: #000;
    font-family: "Roboto", serif;
  }

  .app__portlet-head {
    font-family: "Roboto", serif;
  }

  .kt-portlet__head-title {
    font-family: "Roboto", serif;
  }

  .app_service__form-body {
    font-family: "Roboto", serif;

    fieldset {
      max-width: 900px;
      margin: 0 auto;
    }
  }

  .app_comments {
    &__title {
      margin: 10px 0 0;
    }

    &__comment {
      padding: 8px 0;
      border-bottom: 1px solid #ebedf2;

      &:last-child {
        border-bottom: none;
      }

      &-title {
        color: #838383;
        font-weight: bold;
      }

      &-text {

      }
    }
  }
</style>
